import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=534dc9f0&scoped=true"
import script from "./QuestionContent.vue?vue&type=script&lang=js"
export * from "./QuestionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534dc9f0",
  null
  
)

export default component.exports